export const getExpenditureAmount = (expenditure) => (+expenditure.price * +expenditure.count).toFixed(2);